import { BenefitTypeEnum } from "./enum";

export const BenefitTypeLabels = Object.freeze({
  [BenefitTypeEnum.ACCESS]: "Acesso",
  [BenefitTypeEnum.CREDITS]: "Crédito",
});
